import { GetUserTimeZone, TimeZoneAbbreviated } from 'src/latest/src';
import makeApiRequest from '../../api/makeApiCall';
import { Config } from '../../latest/src/constants/AppServerConfig';


const CALENDER_SERVICE = Config.calenderService;


export const getTherapistSchedules = async (data,offset=  0,limit=10) => {
    return await makeApiRequest(`${CALENDER_SERVICE}calendar/_schedules?offset=${offset}&limit=${limit}`,'POST',data);
};

export const getScheduleSlotStatus = async (slotId:String) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/schedules/${slotId}/_status`,
       
    );
};

// API to block the slot

export const blockScheduleSlot = async (data: Object,slotId:String) => {
    if (data) {
        const currentDate = new Date();

        data.user_time_zone = GetUserTimeZone();

        data.user_time_zone_key = TimeZoneAbbreviated(currentDate.toDateString());
    }

    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/schedules/${slotId}/_block`,
        "POST",
        data
    );
};

export const getSchedules = async (data: Object, offset: Number = 0,limit: Number = 100) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/_schedules?limit=${limit}&offset=${offset}`,
        "POST",
        data
    );
};

export const createEvent = async (
    data: Object,
   
) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/events`,
        "POST",
        data
    );
};

export const deleteAllTypeEvent = async (eventId: String, isRecurrent: Boolean, selectedOption: String | null) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/events/${eventId}${selectedOption === `Deletethewholeseries` ? `?delete_series=${isRecurrent}` : selectedOption === `Deletefutureevent` ? `?delete_future_events=${isRecurrent}` : ""} `,
        "DELETE"
    );
};

export const editEvent = async (eventId: String,data:Object) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/events/${eventId}`,
        "PUT",
        data
    );
};


export const getSchedulesV2 = async (
    data: Object,
   
) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}event-rule/_search`,
        "POST",
        data
    );
};

export const getAppointments = async (data: Object) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/appointment/_search`,
        "POST",
        data
    );
};

export const getClientAppointments = async (data: Object) => {
    return await makeApiRequest(
        `${CALENDER_SERVICE}calendar/appointment/client/_search`,
        "POST",
        data
    );
};

export const deleteAppointment = async (
  eventId: String,
) => {
  return await makeApiRequest(
    `${CALENDER_SERVICE}calendar/appointment/${eventId} `,
    'DELETE',
  );
};